// @generated
// This file is automatically generated by Kanel. Do not modify manually.

import { userId, type UserId } from './User';
import type { ColumnType, Selectable, Insertable, Updateable } from 'kysely';
import { z } from 'zod';

/** Identifier type for public.api_key */
export type ApiKeyId = string & { __brand: 'public.api_key' };

/** Represents the table public.api_key */
export default interface ApiKeyTable {
  id: ColumnType<ApiKeyId, ApiKeyId | undefined, ApiKeyId>;

  key: ColumnType<string, string | undefined, string>;

  user_id: ColumnType<UserId | null, UserId | null, UserId | null>;

  _created_at: ColumnType<string, string | undefined, string>;
}

export type ApiKey = Selectable<ApiKeyTable>;

export type NewApiKey = Insertable<ApiKeyTable>;

export type ApiKeyUpdate = Updateable<ApiKeyTable>;

export const apiKeyId = z.string() as unknown as z.Schema<ApiKeyId>;

export const apiKey = z.object({
  id: apiKeyId,
  key: z.string(),
  user_id: userId.nullable(),
  _created_at: z.string(),
}) as unknown as z.Schema<ApiKey>;

export const apiKeyInitializer = z.object({
  id: apiKeyId.optional(),
  key: z.string().optional(),
  user_id: userId.optional().nullable(),
}) as unknown as z.Schema<ApiKeyInitializer>;

export const apiKeyMutator = z.object({
  id: apiKeyId.optional(),
  key: z.string().optional(),
  user_id: userId.optional().nullable(),
}) as unknown as z.Schema<ApiKeyMutator>;
